/**
 * Reading a refusal without guessing at its shape.
 *
 * Hand-written, and deliberately outside `shared/api`. That directory is
 * emptied and rewritten by the generator, so anything of ours left in it would
 * disappear at the next regeneration — which is exactly what the drift test
 * caught when this file started out there.
 *
 * Nothing here decides anything about money or permissions. It reads a status
 * code and says whether it means the session ended.
 */

/** A failed request the client surfaced, whatever else it carries. */
type WithStatus = { readonly status?: unknown; readonly response?: { status?: unknown } };

export function statusOf(error: unknown): number | null {
  if (typeof error !== "object" || error === null) return null;
  const shaped = error as WithStatus;
  if (typeof shaped.status === "number") return shaped.status;
  const nested = shaped.response;
  if (nested && typeof nested.status === "number") return nested.status;
  return null;
}

/**
 * Whether this is the session having ended.
 *
 * Only 401. A 403 would mean the session is fine and the action is not
 * allowed, and signing somebody out for it would hide the real answer.
 */
export function isUnauthorized(error: unknown): boolean {
  return statusOf(error) === 401;
}
